export enum PermissionType {
  HIDDEN_CAN_SEE_OTHERS = 1,
  VISIBLE_CANT_SEE_OTHERS = 2,
  VISIBLE_CAN_SEE_OTHERS = 3,
  HIDDEN_CANT_SEE_OTHERS = 4,
}
